var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBsFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 24",
    width: 24,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002395",
    d: "M0 0h40v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fecb00",
    d: "M11 0h24v24z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fontSize: 7,
    fontFamily: "sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 3
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 9,
    y: 7
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 11
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 17,
    y: 15
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 21,
    y: 19
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 23
  }, "\u2605"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsFlag);
export default __webpack_public_path__ + "static/media/bs-flag.5b88e3a7.svg";
export { ForwardRef as ReactComponent };